export function Terms() {
  return (
    <div className="min-h-screen bg-foretell-bg text-slate-100 p-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>

        <div className="space-y-6 text-slate-300">
          <p className="text-sm text-slate-400">Last updated: January 2025</p>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Foretell ("the Service"), you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">2. Description of Service</h2>
            <p>
              Foretell is a prediction tracking application integrated with Discord. Users can create predictions,
              vote on outcomes, and track their prediction accuracy over time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">3. User Accounts</h2>
            <p>
              To use certain features of the Service, you must authenticate via Discord. You are responsible
              for maintaining the security of your Discord account. You agree not to share your account
              credentials with others.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">4. User Content</h2>
            <p>
              You retain ownership of predictions and content you create. By posting content, you grant us
              a license to display and distribute that content within the Service. You agree not to post
              content that is illegal, harmful, threatening, abusive, or otherwise objectionable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">5. Prohibited Uses</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Use the Service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Interfere with or disrupt the Service</li>
              <li>Use automated systems to access the Service without permission</li>
              <li>Impersonate others or misrepresent your affiliation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">6. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to the Service at any time,
              with or without cause, and with or without notice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">7. Disclaimer of Warranties</h2>
            <p>
              The Service is provided "as is" without warranties of any kind. We do not guarantee that
              the Service will be uninterrupted, secure, or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">8. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, we shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages arising from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">9. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the Service after changes constitutes
              acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">10. Contact</h2>
            <p>
              For questions about these Terms, please contact us through our Discord server or GitHub repository.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
